module.exports = __webpack_public_path__ + "static/media/student-score-100p.200a818b.png";